exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "section-title{display:block}section-title h2{color:#0072c9;font-family:Stag Sans;font-size:24px;font-weight:400;margin:20px 0 0}section-title header.mobile h2{color:#0072c9;font-family:Stag Sans;font-size:16px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./client/app/loans.module/components/sectionTitle/sectionTitle.scss
// module id = 2157
// module chunks = 0